// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/connections/public/v1/commands_api.proto (package gdx.connections.public.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { AcceptPowerLikeCommand, BlockUserCommand, CancelPowerLikeCommand, ClearDialogCommand, DeleteMessagesCommand, MakeDialogReadCommand, RemoveDialogsCommand, ReportUserCommand, RequestPhotoCommand, SendLikeCommand, SendMessageCommand, SendPowerLikeCommand, UnblockUserCommand } from "./commands_pb.js";

/**
 * @generated from message gdx.connections.public.v1.SendLikeCommandRequest
 */
export class SendLikeCommandRequest extends Message<SendLikeCommandRequest> {
  /**
   * @generated from field: gdx.connections.public.v1.SendLikeCommand command = 1;
   */
  command?: SendLikeCommand;

  constructor(data?: PartialMessage<SendLikeCommandRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.SendLikeCommandRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "command", kind: "message", T: SendLikeCommand },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendLikeCommandRequest {
    return new SendLikeCommandRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendLikeCommandRequest {
    return new SendLikeCommandRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendLikeCommandRequest {
    return new SendLikeCommandRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendLikeCommandRequest | PlainMessage<SendLikeCommandRequest> | undefined, b: SendLikeCommandRequest | PlainMessage<SendLikeCommandRequest> | undefined): boolean {
    return proto3.util.equals(SendLikeCommandRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.SendLikeCommandResponse
 */
export class SendLikeCommandResponse extends Message<SendLikeCommandResponse> {
  constructor(data?: PartialMessage<SendLikeCommandResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.SendLikeCommandResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendLikeCommandResponse {
    return new SendLikeCommandResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendLikeCommandResponse {
    return new SendLikeCommandResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendLikeCommandResponse {
    return new SendLikeCommandResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendLikeCommandResponse | PlainMessage<SendLikeCommandResponse> | undefined, b: SendLikeCommandResponse | PlainMessage<SendLikeCommandResponse> | undefined): boolean {
    return proto3.util.equals(SendLikeCommandResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.SendPowerLikeCommandRequest
 */
export class SendPowerLikeCommandRequest extends Message<SendPowerLikeCommandRequest> {
  /**
   * @generated from field: gdx.connections.public.v1.SendPowerLikeCommand command = 1;
   */
  command?: SendPowerLikeCommand;

  constructor(data?: PartialMessage<SendPowerLikeCommandRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.SendPowerLikeCommandRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "command", kind: "message", T: SendPowerLikeCommand },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendPowerLikeCommandRequest {
    return new SendPowerLikeCommandRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendPowerLikeCommandRequest {
    return new SendPowerLikeCommandRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendPowerLikeCommandRequest {
    return new SendPowerLikeCommandRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendPowerLikeCommandRequest | PlainMessage<SendPowerLikeCommandRequest> | undefined, b: SendPowerLikeCommandRequest | PlainMessage<SendPowerLikeCommandRequest> | undefined): boolean {
    return proto3.util.equals(SendPowerLikeCommandRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.SendPowerLikeCommandResponse
 */
export class SendPowerLikeCommandResponse extends Message<SendPowerLikeCommandResponse> {
  constructor(data?: PartialMessage<SendPowerLikeCommandResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.SendPowerLikeCommandResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendPowerLikeCommandResponse {
    return new SendPowerLikeCommandResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendPowerLikeCommandResponse {
    return new SendPowerLikeCommandResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendPowerLikeCommandResponse {
    return new SendPowerLikeCommandResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendPowerLikeCommandResponse | PlainMessage<SendPowerLikeCommandResponse> | undefined, b: SendPowerLikeCommandResponse | PlainMessage<SendPowerLikeCommandResponse> | undefined): boolean {
    return proto3.util.equals(SendPowerLikeCommandResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.AcceptPowerLikeCommandRequest
 */
export class AcceptPowerLikeCommandRequest extends Message<AcceptPowerLikeCommandRequest> {
  /**
   * @generated from field: gdx.connections.public.v1.AcceptPowerLikeCommand command = 1;
   */
  command?: AcceptPowerLikeCommand;

  constructor(data?: PartialMessage<AcceptPowerLikeCommandRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.AcceptPowerLikeCommandRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "command", kind: "message", T: AcceptPowerLikeCommand },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AcceptPowerLikeCommandRequest {
    return new AcceptPowerLikeCommandRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AcceptPowerLikeCommandRequest {
    return new AcceptPowerLikeCommandRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AcceptPowerLikeCommandRequest {
    return new AcceptPowerLikeCommandRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AcceptPowerLikeCommandRequest | PlainMessage<AcceptPowerLikeCommandRequest> | undefined, b: AcceptPowerLikeCommandRequest | PlainMessage<AcceptPowerLikeCommandRequest> | undefined): boolean {
    return proto3.util.equals(AcceptPowerLikeCommandRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.AcceptPowerLikeCommandResponse
 */
export class AcceptPowerLikeCommandResponse extends Message<AcceptPowerLikeCommandResponse> {
  constructor(data?: PartialMessage<AcceptPowerLikeCommandResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.AcceptPowerLikeCommandResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AcceptPowerLikeCommandResponse {
    return new AcceptPowerLikeCommandResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AcceptPowerLikeCommandResponse {
    return new AcceptPowerLikeCommandResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AcceptPowerLikeCommandResponse {
    return new AcceptPowerLikeCommandResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AcceptPowerLikeCommandResponse | PlainMessage<AcceptPowerLikeCommandResponse> | undefined, b: AcceptPowerLikeCommandResponse | PlainMessage<AcceptPowerLikeCommandResponse> | undefined): boolean {
    return proto3.util.equals(AcceptPowerLikeCommandResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.CancelPowerLikeCommandRequest
 */
export class CancelPowerLikeCommandRequest extends Message<CancelPowerLikeCommandRequest> {
  /**
   * @generated from field: gdx.connections.public.v1.CancelPowerLikeCommand command = 1;
   */
  command?: CancelPowerLikeCommand;

  constructor(data?: PartialMessage<CancelPowerLikeCommandRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.CancelPowerLikeCommandRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "command", kind: "message", T: CancelPowerLikeCommand },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelPowerLikeCommandRequest {
    return new CancelPowerLikeCommandRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelPowerLikeCommandRequest {
    return new CancelPowerLikeCommandRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelPowerLikeCommandRequest {
    return new CancelPowerLikeCommandRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CancelPowerLikeCommandRequest | PlainMessage<CancelPowerLikeCommandRequest> | undefined, b: CancelPowerLikeCommandRequest | PlainMessage<CancelPowerLikeCommandRequest> | undefined): boolean {
    return proto3.util.equals(CancelPowerLikeCommandRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.CancelPowerLikeCommandResponse
 */
export class CancelPowerLikeCommandResponse extends Message<CancelPowerLikeCommandResponse> {
  constructor(data?: PartialMessage<CancelPowerLikeCommandResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.CancelPowerLikeCommandResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelPowerLikeCommandResponse {
    return new CancelPowerLikeCommandResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelPowerLikeCommandResponse {
    return new CancelPowerLikeCommandResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelPowerLikeCommandResponse {
    return new CancelPowerLikeCommandResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CancelPowerLikeCommandResponse | PlainMessage<CancelPowerLikeCommandResponse> | undefined, b: CancelPowerLikeCommandResponse | PlainMessage<CancelPowerLikeCommandResponse> | undefined): boolean {
    return proto3.util.equals(CancelPowerLikeCommandResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.BlockUserCommandRequest
 */
export class BlockUserCommandRequest extends Message<BlockUserCommandRequest> {
  /**
   * @generated from field: gdx.connections.public.v1.BlockUserCommand command = 1;
   */
  command?: BlockUserCommand;

  constructor(data?: PartialMessage<BlockUserCommandRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.BlockUserCommandRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "command", kind: "message", T: BlockUserCommand },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BlockUserCommandRequest {
    return new BlockUserCommandRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BlockUserCommandRequest {
    return new BlockUserCommandRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BlockUserCommandRequest {
    return new BlockUserCommandRequest().fromJsonString(jsonString, options);
  }

  static equals(a: BlockUserCommandRequest | PlainMessage<BlockUserCommandRequest> | undefined, b: BlockUserCommandRequest | PlainMessage<BlockUserCommandRequest> | undefined): boolean {
    return proto3.util.equals(BlockUserCommandRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.BlockUserCommandResponse
 */
export class BlockUserCommandResponse extends Message<BlockUserCommandResponse> {
  constructor(data?: PartialMessage<BlockUserCommandResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.BlockUserCommandResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BlockUserCommandResponse {
    return new BlockUserCommandResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BlockUserCommandResponse {
    return new BlockUserCommandResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BlockUserCommandResponse {
    return new BlockUserCommandResponse().fromJsonString(jsonString, options);
  }

  static equals(a: BlockUserCommandResponse | PlainMessage<BlockUserCommandResponse> | undefined, b: BlockUserCommandResponse | PlainMessage<BlockUserCommandResponse> | undefined): boolean {
    return proto3.util.equals(BlockUserCommandResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.UnblockUserCommandRequest
 */
export class UnblockUserCommandRequest extends Message<UnblockUserCommandRequest> {
  /**
   * @generated from field: gdx.connections.public.v1.UnblockUserCommand command = 1;
   */
  command?: UnblockUserCommand;

  constructor(data?: PartialMessage<UnblockUserCommandRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.UnblockUserCommandRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "command", kind: "message", T: UnblockUserCommand },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnblockUserCommandRequest {
    return new UnblockUserCommandRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnblockUserCommandRequest {
    return new UnblockUserCommandRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnblockUserCommandRequest {
    return new UnblockUserCommandRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UnblockUserCommandRequest | PlainMessage<UnblockUserCommandRequest> | undefined, b: UnblockUserCommandRequest | PlainMessage<UnblockUserCommandRequest> | undefined): boolean {
    return proto3.util.equals(UnblockUserCommandRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.UnblockUserCommandResponse
 */
export class UnblockUserCommandResponse extends Message<UnblockUserCommandResponse> {
  constructor(data?: PartialMessage<UnblockUserCommandResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.UnblockUserCommandResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnblockUserCommandResponse {
    return new UnblockUserCommandResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnblockUserCommandResponse {
    return new UnblockUserCommandResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnblockUserCommandResponse {
    return new UnblockUserCommandResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UnblockUserCommandResponse | PlainMessage<UnblockUserCommandResponse> | undefined, b: UnblockUserCommandResponse | PlainMessage<UnblockUserCommandResponse> | undefined): boolean {
    return proto3.util.equals(UnblockUserCommandResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.ReportUserCommandRequest
 */
export class ReportUserCommandRequest extends Message<ReportUserCommandRequest> {
  /**
   * @generated from field: gdx.connections.public.v1.ReportUserCommand command = 1;
   */
  command?: ReportUserCommand;

  constructor(data?: PartialMessage<ReportUserCommandRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.ReportUserCommandRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "command", kind: "message", T: ReportUserCommand },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportUserCommandRequest {
    return new ReportUserCommandRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportUserCommandRequest {
    return new ReportUserCommandRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportUserCommandRequest {
    return new ReportUserCommandRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ReportUserCommandRequest | PlainMessage<ReportUserCommandRequest> | undefined, b: ReportUserCommandRequest | PlainMessage<ReportUserCommandRequest> | undefined): boolean {
    return proto3.util.equals(ReportUserCommandRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.ReportUserCommandResponse
 */
export class ReportUserCommandResponse extends Message<ReportUserCommandResponse> {
  constructor(data?: PartialMessage<ReportUserCommandResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.ReportUserCommandResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportUserCommandResponse {
    return new ReportUserCommandResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportUserCommandResponse {
    return new ReportUserCommandResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportUserCommandResponse {
    return new ReportUserCommandResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ReportUserCommandResponse | PlainMessage<ReportUserCommandResponse> | undefined, b: ReportUserCommandResponse | PlainMessage<ReportUserCommandResponse> | undefined): boolean {
    return proto3.util.equals(ReportUserCommandResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.ClearDialogCommandRequest
 */
export class ClearDialogCommandRequest extends Message<ClearDialogCommandRequest> {
  /**
   * @generated from field: gdx.connections.public.v1.ClearDialogCommand command = 1;
   */
  command?: ClearDialogCommand;

  constructor(data?: PartialMessage<ClearDialogCommandRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.ClearDialogCommandRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "command", kind: "message", T: ClearDialogCommand },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClearDialogCommandRequest {
    return new ClearDialogCommandRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClearDialogCommandRequest {
    return new ClearDialogCommandRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClearDialogCommandRequest {
    return new ClearDialogCommandRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ClearDialogCommandRequest | PlainMessage<ClearDialogCommandRequest> | undefined, b: ClearDialogCommandRequest | PlainMessage<ClearDialogCommandRequest> | undefined): boolean {
    return proto3.util.equals(ClearDialogCommandRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.ClearDialogCommandResponse
 */
export class ClearDialogCommandResponse extends Message<ClearDialogCommandResponse> {
  constructor(data?: PartialMessage<ClearDialogCommandResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.ClearDialogCommandResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClearDialogCommandResponse {
    return new ClearDialogCommandResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClearDialogCommandResponse {
    return new ClearDialogCommandResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClearDialogCommandResponse {
    return new ClearDialogCommandResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ClearDialogCommandResponse | PlainMessage<ClearDialogCommandResponse> | undefined, b: ClearDialogCommandResponse | PlainMessage<ClearDialogCommandResponse> | undefined): boolean {
    return proto3.util.equals(ClearDialogCommandResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.RemoveDialogsCommandRequest
 */
export class RemoveDialogsCommandRequest extends Message<RemoveDialogsCommandRequest> {
  /**
   * @generated from field: gdx.connections.public.v1.RemoveDialogsCommand command = 1;
   */
  command?: RemoveDialogsCommand;

  constructor(data?: PartialMessage<RemoveDialogsCommandRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.RemoveDialogsCommandRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "command", kind: "message", T: RemoveDialogsCommand },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RemoveDialogsCommandRequest {
    return new RemoveDialogsCommandRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RemoveDialogsCommandRequest {
    return new RemoveDialogsCommandRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RemoveDialogsCommandRequest {
    return new RemoveDialogsCommandRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RemoveDialogsCommandRequest | PlainMessage<RemoveDialogsCommandRequest> | undefined, b: RemoveDialogsCommandRequest | PlainMessage<RemoveDialogsCommandRequest> | undefined): boolean {
    return proto3.util.equals(RemoveDialogsCommandRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.RemoveDialogsCommandResponse
 */
export class RemoveDialogsCommandResponse extends Message<RemoveDialogsCommandResponse> {
  constructor(data?: PartialMessage<RemoveDialogsCommandResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.RemoveDialogsCommandResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RemoveDialogsCommandResponse {
    return new RemoveDialogsCommandResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RemoveDialogsCommandResponse {
    return new RemoveDialogsCommandResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RemoveDialogsCommandResponse {
    return new RemoveDialogsCommandResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RemoveDialogsCommandResponse | PlainMessage<RemoveDialogsCommandResponse> | undefined, b: RemoveDialogsCommandResponse | PlainMessage<RemoveDialogsCommandResponse> | undefined): boolean {
    return proto3.util.equals(RemoveDialogsCommandResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.SendMessageCommandRequest
 */
export class SendMessageCommandRequest extends Message<SendMessageCommandRequest> {
  /**
   * @generated from field: gdx.connections.public.v1.SendMessageCommand command = 1;
   */
  command?: SendMessageCommand;

  constructor(data?: PartialMessage<SendMessageCommandRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.SendMessageCommandRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "command", kind: "message", T: SendMessageCommand },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendMessageCommandRequest {
    return new SendMessageCommandRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendMessageCommandRequest {
    return new SendMessageCommandRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendMessageCommandRequest {
    return new SendMessageCommandRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendMessageCommandRequest | PlainMessage<SendMessageCommandRequest> | undefined, b: SendMessageCommandRequest | PlainMessage<SendMessageCommandRequest> | undefined): boolean {
    return proto3.util.equals(SendMessageCommandRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.SendMessageCommandResponse
 */
export class SendMessageCommandResponse extends Message<SendMessageCommandResponse> {
  constructor(data?: PartialMessage<SendMessageCommandResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.SendMessageCommandResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendMessageCommandResponse {
    return new SendMessageCommandResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendMessageCommandResponse {
    return new SendMessageCommandResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendMessageCommandResponse {
    return new SendMessageCommandResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendMessageCommandResponse | PlainMessage<SendMessageCommandResponse> | undefined, b: SendMessageCommandResponse | PlainMessage<SendMessageCommandResponse> | undefined): boolean {
    return proto3.util.equals(SendMessageCommandResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.MakeDialogReadCommandRequest
 */
export class MakeDialogReadCommandRequest extends Message<MakeDialogReadCommandRequest> {
  /**
   * @generated from field: gdx.connections.public.v1.MakeDialogReadCommand command = 1;
   */
  command?: MakeDialogReadCommand;

  constructor(data?: PartialMessage<MakeDialogReadCommandRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.MakeDialogReadCommandRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "command", kind: "message", T: MakeDialogReadCommand },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MakeDialogReadCommandRequest {
    return new MakeDialogReadCommandRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MakeDialogReadCommandRequest {
    return new MakeDialogReadCommandRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MakeDialogReadCommandRequest {
    return new MakeDialogReadCommandRequest().fromJsonString(jsonString, options);
  }

  static equals(a: MakeDialogReadCommandRequest | PlainMessage<MakeDialogReadCommandRequest> | undefined, b: MakeDialogReadCommandRequest | PlainMessage<MakeDialogReadCommandRequest> | undefined): boolean {
    return proto3.util.equals(MakeDialogReadCommandRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.MakeDialogReadCommandResponse
 */
export class MakeDialogReadCommandResponse extends Message<MakeDialogReadCommandResponse> {
  constructor(data?: PartialMessage<MakeDialogReadCommandResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.MakeDialogReadCommandResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MakeDialogReadCommandResponse {
    return new MakeDialogReadCommandResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MakeDialogReadCommandResponse {
    return new MakeDialogReadCommandResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MakeDialogReadCommandResponse {
    return new MakeDialogReadCommandResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MakeDialogReadCommandResponse | PlainMessage<MakeDialogReadCommandResponse> | undefined, b: MakeDialogReadCommandResponse | PlainMessage<MakeDialogReadCommandResponse> | undefined): boolean {
    return proto3.util.equals(MakeDialogReadCommandResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.DeleteMessagesCommandRequest
 */
export class DeleteMessagesCommandRequest extends Message<DeleteMessagesCommandRequest> {
  /**
   * @generated from field: gdx.connections.public.v1.DeleteMessagesCommand command = 1;
   */
  command?: DeleteMessagesCommand;

  constructor(data?: PartialMessage<DeleteMessagesCommandRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.DeleteMessagesCommandRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "command", kind: "message", T: DeleteMessagesCommand },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteMessagesCommandRequest {
    return new DeleteMessagesCommandRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteMessagesCommandRequest {
    return new DeleteMessagesCommandRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteMessagesCommandRequest {
    return new DeleteMessagesCommandRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteMessagesCommandRequest | PlainMessage<DeleteMessagesCommandRequest> | undefined, b: DeleteMessagesCommandRequest | PlainMessage<DeleteMessagesCommandRequest> | undefined): boolean {
    return proto3.util.equals(DeleteMessagesCommandRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.DeleteMessagesCommandResponse
 */
export class DeleteMessagesCommandResponse extends Message<DeleteMessagesCommandResponse> {
  constructor(data?: PartialMessage<DeleteMessagesCommandResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.DeleteMessagesCommandResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteMessagesCommandResponse {
    return new DeleteMessagesCommandResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteMessagesCommandResponse {
    return new DeleteMessagesCommandResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteMessagesCommandResponse {
    return new DeleteMessagesCommandResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteMessagesCommandResponse | PlainMessage<DeleteMessagesCommandResponse> | undefined, b: DeleteMessagesCommandResponse | PlainMessage<DeleteMessagesCommandResponse> | undefined): boolean {
    return proto3.util.equals(DeleteMessagesCommandResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.RequestPhotoCommandRequest
 */
export class RequestPhotoCommandRequest extends Message<RequestPhotoCommandRequest> {
  /**
   * @generated from field: gdx.connections.public.v1.RequestPhotoCommand command = 1;
   */
  command?: RequestPhotoCommand;

  constructor(data?: PartialMessage<RequestPhotoCommandRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.RequestPhotoCommandRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "command", kind: "message", T: RequestPhotoCommand },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RequestPhotoCommandRequest {
    return new RequestPhotoCommandRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RequestPhotoCommandRequest {
    return new RequestPhotoCommandRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RequestPhotoCommandRequest {
    return new RequestPhotoCommandRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RequestPhotoCommandRequest | PlainMessage<RequestPhotoCommandRequest> | undefined, b: RequestPhotoCommandRequest | PlainMessage<RequestPhotoCommandRequest> | undefined): boolean {
    return proto3.util.equals(RequestPhotoCommandRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.RequestPhotoCommandResponse
 */
export class RequestPhotoCommandResponse extends Message<RequestPhotoCommandResponse> {
  constructor(data?: PartialMessage<RequestPhotoCommandResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.RequestPhotoCommandResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RequestPhotoCommandResponse {
    return new RequestPhotoCommandResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RequestPhotoCommandResponse {
    return new RequestPhotoCommandResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RequestPhotoCommandResponse {
    return new RequestPhotoCommandResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RequestPhotoCommandResponse | PlainMessage<RequestPhotoCommandResponse> | undefined, b: RequestPhotoCommandResponse | PlainMessage<RequestPhotoCommandResponse> | undefined): boolean {
    return proto3.util.equals(RequestPhotoCommandResponse, a, b);
  }
}

